export default __webpack_public_path__ + "static/media/logo-white.702e1cb6.svg";